export const getImageUrl = (type) => {
    switch (type) {
        case 2:
            return "https://img10.360buyimg.com/imgzone/jfs/t1/47087/12/24186/9010/64085b48F25877e75/77579d7a919761d3.png"
            break;
        case 3:
            return "https://img10.360buyimg.com/imgzone/jfs/t1/151468/31/29211/8831/64085dceF02f291cd/824258168376431b.png"
        default:
            break;
    }
}

export const getUrlQueryValueByKey = (url, key) => {
    let reg = new RegExp("(^|[&?])" + key + "=([^&]*)(&|$)");
    let r = url.match(reg); //search,查询？后面的参数，并匹配正则
    // if (r != null) return unescape(r[2]);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
};

// 活动规则格式化
export const ruleFormat = (rule) => {
    //活动规则格式化
    if (rule == '') {
        return "暂无规则";
    } else {
        let rules = rule.split("\n");
        let ua = navigator.userAgent.toLowerCase();
        // if (/iphone|ipad|ipod/.test(ua)) {
        //     rules.push("本次活动为商家自发举办，与苹果公司及App Store无关；");
        // }
        return rules.join("<br/>");
    }
}

//判断环境  小程序返回true
export const isMiniProgram = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    // 判断是否在小程序环境中打开
    if (userAgent.indexOf("miniprogram") !== -1) {
        return true
    } else {
        return false
    }
}

//判断系统  苹果返回true
export const isAndroid = () => {
    var userAgent = navigator.userAgent;
    return userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
}

//判断ios系统
export const isiOS = () => {
    var userAgent = navigator.userAgent;
    return !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

export const getResourceBaseUrl = () => {
    var url = location.href.indexOf('test') ? 'https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/webResource/test/' : ''
    var a = location.href.split('?').length > 2 ? location.href.split('?')[1].split('/') : location.href.split('?')[0].split('/')
    // 有的页面路径仅有一层 加个判断
    url += a[a.length - 2].indexOf('#') != -1 ? `${a[a.length - 1]}`:`${a[a.length - 2]}/${a[a.length - 1]}`
    return url
}

export const getQueryParams = () => {
    const params = {};
    const search = location.href
    if (!search) {
        return params;
    }
    search.split('&').forEach((pair) => {
        const [key, value] = pair.split('=');
        params[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    return params;
}